import Tooltip from "./tooltip"
import Svg from "../svg"

export default function TooltipInfo({ children, icon = "info", position }) {
  return (
    <Tooltip position={position}>
      <Tooltip.Trigger>
        <Svg classes="w-4 h-4 mt-[1px]" name={icon} />
      </Tooltip.Trigger>
      <Tooltip.Content>{children}</Tooltip.Content>
    </Tooltip>
  )
}
